module.exports = __webpack_public_path__ + "img/thescore.94121bdf.png";